export default "__VITE_ASSET__2Lj3jKZh__"